export default "__VITE_ASSET__Df1wQCRa__"